export function calcAvgRating(reviews) {
  if (reviews.length === 0) return 0;

  const sum = reviews.reduce((sum, review) => sum + review.main_rating, 0);

  return sum / reviews.length;
}
